module.exports = __webpack_public_path__ + "static/media/Vector-14.5924da71.svg";